<template>
  <div
    class="transactions-table-status-column-content"
    :class="{
      'text-success': isSucceed,
      'text-alert': isRejected || isFailed,
      'text-warning': isPending,
    }"
  >
    <template v-if="isSucceed">
      <i class="el-icon-check transactions-table-status-column-content__icon" />
      {{ statusText }}
    </template>
    <template v-else-if="isPending">
      <i class="el-icon-user transactions-table-status-column-content__icon" />
      {{ statusText }}
    </template>
    <template v-else-if="isRejected">
      <i class="el-icon-close transactions-table-status-column-content__icon" />
      {{ statusText }}
    </template>
    <template v-else>
      <i class="el-icon-close transactions-table-status-column-content__icon" />
      {{ statusText }}
    </template>
  </div>
</template>

<script>
export default {
  name: 'TransactionsTableStatusColumnContent',
  props: {
    status: {
      type: String,
      required: true,
    },
    statusText: {
      type: String,
      required: true,
    },
  },
  computed: {
    statuses() {
      return {
        SUCCESS: 'successful',
        FAILURE: 'failed',
        REJECTED: 'rejected',
        PENDING: 'pending',
      };
    },
    isSucceed() {
      return this.status === this.statuses.SUCCESS;
    },
    isPending() {
      return this.status === this.statuses.PENDING;
    },
    isRejected() {
      return this.status === this.statuses.REJECTED;
    },
    isFailed() {
      return this.status === this.statuses.FAILURE;
    },
  },
};
</script>
<style lang="scss">
.transactions-table-status-column-content {
  display: flex;
  align-items: center;

  &-icon {
    font-weight: bold;

    margin-left: $global-margin;
    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }
  }
}
</style>
